define('Responsive/util/renderComplete',['require','exports','module'],function(require,exports,module){
	var win=window,
		doneRendering = win.setImmediate || win.msSetImmediate;

	if(!doneRendering && win.postMessage){
		var timeouts=[],
			mess='render-ensure',
			domain=win.location.href;

		win.addEventListener('message',function(e){
			if(e.data===mess){
				for(var i=0; i<timeouts.length;i++){
					timeouts.shift()();
				}
				return false;
			}
		},false);
		
		return function(cb){
			timeouts.push(cb);
			win.postMessage(mess,domain);
			return this;
		}
	}

	doneRendering = win.setTimeout;

	return function(cb){
			return doneRendering(cb,4) && this;
	}
});
